import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Heart } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_property-inquiry-hub/artifacts/10zghdqz_IMG_PVH.png';

export const Footer = () => {
  return (
    <footer className="bg-dark-light border-t border-dark-lighter mt-32">
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="PropVanta" className="h-12 w-auto" />
              <div>
                <h3 className="font-heading text-2xl font-bold text-rose-gold">PropVanta</h3>
                <p className="text-white/40 text-xs uppercase tracking-widest">Property Consultants</p>
              </div>
            </div>
            <p className="text-rose-gold/80 italic text-sm mb-4 font-heading">
              "Trusted Property. Real Advantage."
            </p>
            <p className="text-white/60 leading-relaxed text-sm mb-6">
              Your trusted channel partner for premium properties. Expert guidance for all your real estate needs.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-white/60 hover:text-rose-gold transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white/60 hover:text-rose-gold transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-white/60 hover:text-rose-gold transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-rose-gold mb-6">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-white/60 hover:text-rose-gold transition-colors text-sm">
                Home
              </Link>
              <Link to="/projects" className="text-white/60 hover:text-rose-gold transition-colors text-sm">
                Projects
              </Link>
              <Link to="/builders" className="text-white/60 hover:text-rose-gold transition-colors text-sm">
                Builders
              </Link>
              <Link to="/about" className="text-white/60 hover:text-rose-gold transition-colors text-sm">
                About
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-rose-gold transition-colors text-sm">
                Contact
              </Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-rose-gold mb-6">Our Services</h4>
            <div className="flex flex-col gap-3">
              <p className="text-white/60 text-sm">Property Consultation</p>
              <p className="text-white/60 text-sm">Free Site Visits</p>
              <p className="text-white/60 text-sm">Documentation Support</p>
              <p className="text-white/60 text-sm">Investment Guidance</p>
              <p className="text-white/60 text-sm">Home Loan Assistance</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-rose-gold mb-6">Contact Us</h4>
            <div className="flex flex-col gap-4">
              <a href="tel:+917020970161" className="flex items-center gap-3 text-white/60 hover:text-rose-gold transition-colors text-sm group">
                <Phone size={18} className="text-rose-gold group-hover:scale-110 transition-transform" />
                <span>+91 70209 70161</span>
              </a>
              <a href="mailto:info@propvanta.co.in" className="flex items-center gap-3 text-white/60 hover:text-rose-gold transition-colors text-sm group">
                <Mail size={18} className="text-rose-gold group-hover:scale-110 transition-transform" />
                <span>info@propvanta.co.in</span>
              </a>
              <div className="flex items-center gap-3 text-white/60 text-sm">
                <MapPin size={18} className="text-rose-gold" />
                <span>Mumbai, Maharashtra</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-dark-lighter pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm flex items-center gap-2">
            © 2026 PropVanta Property Consultants. Made with <Heart size={14} className="text-rose-gold fill-rose-gold" /> for premium living.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <div className="flex items-center gap-2">
              <span className="text-rose-gold text-lg font-bold">✓</span>
              <span className="text-white/60">Trusted Channel Partner</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-rose-gold text-lg font-bold">✓</span>
              <span className="text-white/60">Verified Listings</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
